// Drawer.jsx
import React, { Suspense } from "react";
import { Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Style from "../../assets/css/main.module.css";
import closeIcon from "../../assets/icons/close.svg";
import sohozLogo from "../../assets/icons/shohoz-secondary.svg";
import { drawerAction, setChildId } from "../../store/features/deviceSlice";

export default function Drawer({ title, children }) {
  const dispatch = useDispatch();
  const { drawer } = useSelector((state) => state.deviceSlice);

  return (
    <Offcanvas
      show={drawer}
      onHide={() => {
        dispatch(drawerAction(false));
        dispatch(setChildId(false));
      }}
      placement="end"
      style={{ width: "460px", height: "100%" }}
    >
      {title ? (
        <div
          className={`${Style.bg_primary} ${Style.fw_600} ${Style.fs_20} text-light d-flex justify-content-between align-items-center px-2 px-md-4 py-2 drawer-header w-100`}
        >
          <div>{title}</div>
          <button
            type="button"
            className={`${Style.bg_none} border-0`}
            onClick={() => {
              dispatch(drawerAction(false));
              dispatch(setChildId(false));
            }}
          >
            <img src={closeIcon} alt="close" />
          </button>
        </div>
      ) : (
        <div
          className={`${Style.bg_primary_200} ${Style.fw_20} ${Style.fs_600} text-light d-flex justify-content-between align-items-center px-4 py-2 w-100`}
        >
          <img src={sohozLogo} alt="shohoz" />
          <button
            type="button"
            className={`${Style.bg_none} border-0`}
            onClick={() => dispatch(drawerAction(false))}
          >
            <img src={closeIcon} alt="close" />
          </button>
        </div>
      )}

      <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
    </Offcanvas>
  );
}
